import extract, {sanitize, replace} from '../core/extract'
import i18n from './i18n'

function interventionPeriodAggregator(result, commitment) {
    result.push(...commitment.interventionPeriods)
    return result
}

function interventionPeriodMapper(interventionPeriods) {
    return (interventionPeriodId) => {
        const interventionPeriod = interventionPeriods.find((ip) => ip.uid == interventionPeriodId)
        return interventionPeriod && interventionPeriod.period.label || interventionPeriodId  
    }
}

function extractError(target, error) {
    const errorType = sanitize(error && error.type)

    if (target) {
        const errorData = error && error.data
        const targetError = target[errorType]

        switch(errorType) {
            case 'interventionPeriodIsIncoherent':
                return targetError && errorData.errors.map((error) => {
                    return targetError[sanitize(error.error)] || null
                })
            default:
                return targetError || null
        }
    }
    return null
}

function replaceError(value, error, getState) {
    if (value) {
        const errorType = sanitize(error && error.type)
        const errorData = error && error.data

        switch(errorType) {
            case 'interventionPeriodIsIncoherent':
                return errorData.errors.map((error, index) => {
                    return replace(value[index], error)
                }).join('. ')
            case 'interventionPeriodOverlapAnothers':
                const state = getState()
                const {provider} = state.provider
                const {contact} = state.provider.contact

                var interventionPeriods = []
                interventionPeriods = provider && provider.activities.reduce(interventionPeriodAggregator, interventionPeriods) || interventionPeriods
                interventionPeriods = contact && contact.commitments.reduce(interventionPeriodAggregator, interventionPeriods) || interventionPeriods
                return value + ' : ' + errorData.interventionPeriodsOverlaped.map(interventionPeriodMapper(interventionPeriods)).join(', ')
            default:
                return replace(value, errorData)
        }
    }
    return value
}

export default function(error, getState) {
    return replaceError(extractError(i18n.errorTypeEnum, error), error, getState)
}


// WEBPACK FOOTER //
// ./lib/provider/errors.js